import { ReactElement, useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { StringParam, useQueryParam } from 'use-query-params'

import { DatadogService } from 'const/monitoring/datadog'
import { usePageContext } from 'context/PageContext'
import { getPath } from 'routing/pagePaths'

import { RUM_SERVICE_MAP, SKIP_TAB_TRACKING } from './rumServiceMap'

interface RumViewTrackerProps {
    service?: DatadogService
    name?: string
}

export function RumViewTracker({
    service: serviceProp,
    name: nameProp,
}: RumViewTrackerProps): ReactElement | null {
    const { pageName } = usePageContext()
    const [tabId] = useQueryParam('tab', StringParam)

    const service = serviceProp ?? RUM_SERVICE_MAP[pageName]

    let effectiveName: string
    if (nameProp) {
        effectiveName = nameProp
    } else {
        const routeTemplate = getPath(pageName)
        const shouldTrackTabs = !SKIP_TAB_TRACKING.has(pageName)
        effectiveName =
            shouldTrackTabs && tabId
                ? `${routeTemplate}/tab/${tabId}`
                : routeTemplate
    }

    useEffect(() => {
        if (service) {
            datadogRum.startView({
                name: effectiveName,
                service: service.toLowerCase(),
                version: VERSION,
            })
        }
    }, [service, effectiveName])

    return null
}
